import { useInTouchChatClient } from '@/lib/in-touch-chat'

let inTouchChat: ReturnType<typeof useInTouchChatClient> | null = null

/**
 * App-scoped Stream Chat client (one instance per page load).
 *
 * Mirrors stream-chat-react's "call useCreateChatClient once at app root".
 * The client does not disconnect on consumer unmount — disconnect explicitly on logout.
 * A module singleton shares reactive client state across unread badge + chat view.
 */
export function useInTouchChat () {
  if (!inTouchChat) {
    inTouchChat = useInTouchChatClient()
  }

  return inTouchChat
}
